import Qs from 'qs';

const convertToArray = object => {
  const array = Object.keys(object).map(key => ({
    key,
    values: object[key],
  }));
  return array.filter(({ values }) => values);
};

const toBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

export default {
  async getOrders({ commit, state }, payload) {
    try {
      const params = payload;
      const { data } = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/complaints/search/orders`,
        {
          params,
          paramsSerializer: params => {
            return Qs.stringify(params);
          },
        },
      );
      commit('setOrdersSearchResult', data.salesOrders);
      commit('setDocument', undefined);
      commit('setActiveStep', 1);
    } catch (error) {
      return error;
    }
  },
  async getLastOrders({ commit, state }, payload) {
    try {
      const params = payload;
      const { data } = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/complaints/search/orders`,
        {
          params,
          paramsSerializer: params => {
            return Qs.stringify(params);
          },
        },
      );
      commit('setLastOrders', data.salesOrders);
    } catch (error) {
      return error;
    }
  },
  async getDocument({ commit, state }, { documentNumber, complaintType }) {
    try {
      commit('clearComplaintList');
      const params = {
        documentNumber,
        complaintType,
        filters: convertToArray(state.activeFilters),
      };
      const {
        data: { document },
      } = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/complaints/document-data`,
        {
          params,
          paramsSerializer: params => {
            return Qs.stringify(params);
          },
        },
      );
      commit('setDocument', document);
      commit('setOrdersSearchResult', []);
    } catch (error) {
      commit('clearDocument');
      if (error?.response?.data?.message) {
        this.$toast.error(`<div class="popupToast__content">${error.response.data.message}</div>`, {
          theme: 'popupToast__inner',
          containerClass: 'popupToast__container',
          keepOnHover: true,
          duration: 4000,
          action: [
            {
              class: 'popupToast__close',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
        });
      }
      return error;
    }
  },

  async changeFilters({ commit, dispatch, state }, { name, value }) {
    try {
      commit('setFilter', { name, value });
      await dispatch('getDocument', state.document.number);
    } catch {}
  },

  async submit({ commit, state }, payload) {
    try {
      const items = await Promise.all(
        state.list
          .filter(({ isActive }) => isActive)
          .map(async item => {
            let additionalLabel = '';

            if (state.type === 'R-nt') {
              additionalLabel = 'Powód reklamacji';
            }

            if (state.type === 'RZ') {
              additionalLabel = 'Dlaczego zwracasz?';
            }

            let reason = item.reason;

            const deviceModel = item.deviceModel;

            if (item.additionalList) {
              reason = ` ${additionalLabel}: ${item.additionalList}. ` + reason;
            }

            if (item.serialNumber) {
              reason = ` Numer seryjny: ${item.serialNumber}. ` + reason;
            }

            return {
              quantity: item.amount,
              deliveryDocumentPositionId: item.position,
              reason,
              deviceModel,
              attachments: await Promise.all(
                item.attachments.map(async attach => ({
                  fileName: attach.name,
                  data: await toBase64(attach),
                })),
              ),
            };
          }),
      );
      const dataToSend = {
        ...payload,
        typeString: state.type,
        items,
      };
      const {
        data: {
          complaintNumbers,
          quantity,
          grandTotal: { grossFormatted, netFormatted, currencyPostfix },
        },
      } = await this.$axios.post(`${this.$config.baseOfixApi}/e-commerce/v1/complaints`, {
        ...dataToSend,
      });
      commit('clearData');
      commit('fetchComplaints');
      return {
        caseId: complaintNumbers.join(', '),
        amount: `${quantity} szt.`,
        net: `${netFormatted} ${currencyPostfix}`,
        gross: `${grossFormatted} ${currencyPostfix}`,
      };
    } catch {
      commit('clearData');
      throw new Error('error');
    }
  },
  async fetchAutocomplete({ commit, state }) {
    try {
      if (state.ordersString === '' && !state.orders.length) {
        commit('setOrders', []);
        return;
      }
      commit('setIsLoadingOrders', true);

      if (state.autocompleteSource) {
        state.autocompleteSource.cancel();
      }
      commit('setAutocompleteSource', this.$axios.CancelToken.source());
      const { data } = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/complaints/search/document-autocomplete`,
        {
          cancelToken: state.autocompleteSource.token,
          params: {
            complaintType: state.type,
            documentNumberQuery: state.ordersString,
          },
        },
      );
      commit('setOrders', data.documents);
      commit('setIsLoadingOrders', false);
    } catch {
      commit('setIsLoadingOrders', false);
    }
  },
};
